import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import { snakeCase } from 'change-case';

const typeOptions = [
  'string',
  'datetime',
  'date',
  'bool',
  'int',
  'decimal',
].map(o => ({
  label: o,
  value: o,
}));

const ReferenceGeneralEventDetailsField = ({ index, value, setFieldValue }) => {
  useEffect(() => {
    const label = value.generalEventDetailLabel;

    if (!value.id) {
      setFieldValue(`referenceGeneralEventDetails.${index}.generalEventDetailName`, snakeCase(label));
    }
  }, [value.generalEventDetailLabel]);

  return (
    <Row form>
      <Col sm={6}>
        <Field
          name={`referenceGeneralEventDetails.${index}.generalEventDetailLabel`}
          label="Label"
          required
        />
      </Col>

      <Col sm={6}>
        <Field
          name={`referenceGeneralEventDetails.${index}.generalEventDetailName`}
          label="Name"
          required
        />
      </Col>

      <Col sm={6}>
        <Field
          name={`referenceGeneralEventDetails.${index}.generalEventDetailCode`}
          label="Code"
        />
      </Col>

      <Col sm={6}>
        <Field
          name={`referenceGeneralEventDetails.${index}.generalEventDetailType`}
          label="Type"
          type="select"
          options={typeOptions}
          required
        />
      </Col>

      <Col sm={4}>
        <Field
          name={`referenceGeneralEventDetails.${index}.isActive`}
          type="checkbox"
          label="Is active"
          placeholder="Yes"
        />
      </Col>

      <Col sm={4}>
        <Field
          name={`referenceGeneralEventDetails.${index}.isRequired`}
          type="checkbox"
          label="Is required"
          placeholder="Yes"
        />
      </Col>

      <Col sm={4}>
        <Field
          name={`referenceGeneralEventDetails.${index}.defaultSortOrder`}
          label="Default sort order"
          type="number"
          required
        />
      </Col>
    </Row>
  );
};

ReferenceGeneralEventDetailsField.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.shape({
    generalEventDetailLabel: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default ReferenceGeneralEventDetailsField;
